// extracted by mini-css-extract-plugin
export default {"form":"PersonForm_form__s-twv","inputContainer":"PersonForm_inputContainer__3d-6u"};